import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const carbonSaleTransactionService = createApi({
    reducerPath: 'carbonSaleTransactionService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['CarbonSaleTransaction'],
    endpoints: (builder) => ({
        getAllCarbonSaleTransaction: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.carbonSaleTransactionController.search}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        saveCarbonSaleTransaction: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.carbonSaleTransactionController.save}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateCarbonSaleTransaction: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.carbonSaleTransactionController.update}/${body.payload.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteCarbonSaleTransaction: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.carbonSaleTransactionController.delete}/${body.id}${body.type ? `?type=${body.type}` : ""}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getCarbonSaleTransactionById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.carbonSaleTransactionController.getById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        bulkUploadCarbonSaleTransaction: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.carbonSaleTransactionController.uploadBulk}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        findAllCarbonSaleTransaction: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.carbonSaleTransactionController.findAll}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
    })
});

export const {
    useGetAllCarbonSaleTransactionMutation,
    useSaveCarbonSaleTransactionMutation,
    useUpdateCarbonSaleTransactionMutation,
    useDeleteCarbonSaleTransactionMutation,
    useGetCarbonSaleTransactionByIdMutation,
    useBulkUploadCarbonSaleTransactionMutation,
    useFindAllCarbonSaleTransactionMutation,
} = carbonSaleTransactionService;
